var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9531 4.0625H3.04688C2.93516 4.0625 2.84375 4.15391 2.84375 4.26562V5.89062C2.84375 6.00234 2.93516 6.09375 3.04688 6.09375H22.9531C23.0648 6.09375 23.1562 6.00234 23.1562 5.89062V4.26562C23.1562 4.15391 23.0648 4.0625 22.9531 4.0625ZM22.9531 19.9062H3.04688C2.93516 19.9062 2.84375 19.9977 2.84375 20.1094V21.7344C2.84375 21.8461 2.93516 21.9375 3.04688 21.9375H22.9531C23.0648 21.9375 23.1562 21.8461 23.1562 21.7344V20.1094C23.1562 19.9977 23.0648 19.9062 22.9531 19.9062ZM22.9531 11.9844H3.04688C2.93516 11.9844 2.84375 12.0758 2.84375 12.1875V13.8125C2.84375 13.9242 2.93516 14.0156 3.04688 14.0156H22.9531C23.0648 14.0156 23.1562 13.9242 23.1562 13.8125V12.1875C23.1562 12.0758 23.0648 11.9844 22.9531 11.9844Z",
    fill: "#5E6088"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.2b64bf8b.svg";
export { ForwardRef as ReactComponent };